import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"height":"150px","overflow":"hidden"} }
const _hoisted_2 = {
  viewBox: "0 0 500 150",
  preserveAspectRatio: "none",
  style: {"height":"100%","width":"100%"}
}
const _hoisted_3 = { class: "p-grid" }
const _hoisted_4 = {
  key: 0,
  class: "p-col-6 current-count"
}
const _hoisted_5 = {
  key: 1,
  class: "p-col-4 p-text-right mdi mdi-alert-outline error-count"
}
const _hoisted_6 = { class: "name-overflow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_Card, { class: "card" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("path", {
            d: "M0.00,92.27 C216.83,150.92 304.30,50 500.00,84 L500.00,0.00 L0.00,0.00 Z",
            style: {"stroke":"none","fill":"rgb(223, 223, 223)"}
          }, null, -1)
        ]))]))
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.currentCount !== -1 || _ctx.count !== -1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.count), 1))
          : _createCommentVNode("", true),
        (_ctx.errorCount > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.errorCount), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.className), 1)
      ])), [
        [
          _directive_tooltip,
          _ctx.className,
          void 0,
          { bottom: true }
        ]
      ])
    ]),
    _: 1
  }))
}